import { render, staticRenderFns } from "./LegalTypeIcon.vue?vue&type=template&id=51f73536"
import script from "./LegalTypeIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./LegalTypeIcon.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports